import React from 'react';
import styled from 'styled-components';

const ViewBox = (props) => {
    return (
        <Box level={props.level}>
            <span className="title text">{props.title}</span>
            <span className="level text">{props.level ? "높음" : "낮음"}</span>
            <figure className="img_box">
                {
                    props.level ? (
                        <img src={require("../../../style/img/triangle-top.png")} alt="수치"/>
                    ) : (
                        <img src={require("../../../style/img/triangle-bottom.png")} alt="수치"/>
                    )
                }
            </figure>
        </Box>
    );
};

const Box = styled.div`
    position: relative;
    display: flex;
    align-items: center;
    height: 46px;
    box-sizing: border-box;
    border: 1px solid #342d3a;
    box-shadow: 0px 7px 5px 0px rgba(0,0,0,0.3);

    &::after {
        content:"";
        position: absolute;
        height: 100%;
        width: 5.4px;
        background-color: ${props => props.level ? "#61a89a" : "#f47c73"};
        left:0;
        top:0;
    }

    & + & {
        margin-top: 15px;
    }

    .title {
        font-size: 14.5px;
        color: #3b3f42;
        font-weight: 600;
        padding: 0 23px;
        position: relative;
        margin-left: 10px;
        letter-spacing: 1.1px;

        &::after {
            content:"";
            position: absolute;
            height: 100%;
            width: 2px;
            background-color:#3b3f42;
            right:0;
            top:0;
            transform:rotate(20deg);
        }
    }

    .level {
        font-size: 14.5px;
        color: #3b3f42;
        font-weight: 600;
        padding: 0 25px;
        position: relative;

        &::after {
            content:"";
            position: absolute;
            height: 100%;
            width: 2px;
            background-color:#3b3f42;
            right:0;
            top:0;
            transform:rotate(20deg);
        }
    }

    .img_box {
        padding: 0 25px;
    }
`;

export default ViewBox;
